export const setOpenFinishSignUpModal = 'setOpenFinishSignUpModal';
export const setOpenDownloadAppModal = 'setOpenDownloadAppModal';